import { DiffSyncSchema } from "@megaron/diff-sync-contracts";
import { Serializers, SerializerValue } from "@megaron/serializers";
import { uuidSerializer } from "@megaron/uuid";

export const pricingRuleCustomerFieldsSerializer = Serializers.object({
  priceList: Serializers.string.nullable(),
  defaultDiscount: Serializers.decimal.nullable(),
  pricingNotes: Serializers.string,
  pricingModifiedAt: Serializers.datetime.nullable(),
  pricingModifiedBy: Serializers.string.nullable(),
});

export type PricingRuleCustomerFields = SerializerValue<typeof pricingRuleCustomerFieldsSerializer>;

export const pricingRuleSheetRowSerializer = Serializers.object({
  priceList: Serializers.string,
  customerId: uuidSerializer.nullable({ emptyStrAsNull: true }),
  customerName: Serializers.string.nullable({ emptyStrAsNull: true }),
  defaultDiscount: Serializers.decimal,
  notes: Serializers.string,
});

export type PricingRuleSheetRow = SerializerValue<typeof pricingRuleSheetRowSerializer>;

export const crmDiffSyncSchema = DiffSyncSchema({
  sheetsPricingRule: pricingRuleSheetRowSerializer.partial(),
});

export type CrmDiffSyncChannel = keyof typeof crmDiffSyncSchema & string;
